// import Chart from 'react-apexcharts';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Panel } from 'primereact/panel';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { selectCurrentEmpid } from '../../pages/login/authSlice';
import {
    useGetScoreCardDisputesQuery,
    useGetTeamLeadScorecardAgentsQuery,
} from '../../pages/scorecardDashboard/scorecardDashboardSlice';
import MessageInfo from '../messageInfo/MessageInfo';
import { ScoreCardDashboardViewTable } from '../scoreCardDashboardTable/ScoreCardDashboardViewTable';
import { exportExcel } from '../scoreCardDashboardTable/scorecard-dashboard-view-table-service';
import { useGetScorecardAgentsQuery } from '../scoreCardFilter/scoreCardFilterSlice';
import { ScorecardDisputesTable } from '../scorecardDisputesTable/ScorecardDisputesTable';
import AgentScoreCardDashboardTabs from '../../features/scorecardDashboard/agentScoreCardDashboard/AgentScoreCardDashboardTabs';

type scoreCardEdsProps = {
    inputScorecardVersion: number;
    inputYear: number;
    inputMonth: number;
    module?: string;
};

export const ScoreCardEds = ({ inputMonth, inputYear, inputScorecardVersion, module }: scoreCardEdsProps) => {
    const [supervisorNumber, setSupervisorNumber] = useState();
    const [tlAgentData, setTlAgentData] = useState<any>([]);
    const empNum = Number(useSelector(selectCurrentEmpid));
    const [listOfTls, setListOfTls] = useState<EmployeeTL>([{ name: '', id: '' }]);
    const [agents, setAgents] = useState<any>(null);
    const [metricColHeader, setMetricColHeader] = useState<any>([]);

    /* supervisorNumber DDL */
    const { data: scorecardSupervisorsData } = useGetScorecardAgentsQuery(
        {
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: inputScorecardVersion,
            scorecardRoleId: 2,
        },
        { skip: !inputYear || !inputMonth || !inputScorecardVersion }
    );

    /* agent details per scorecard-Supervisor*/
    const { data: teamLeadScorecardAgentData } = useGetTeamLeadScorecardAgentsQuery(
        {
            employeenumber: supervisorNumber,
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: inputScorecardVersion,
        },
        { skip: !inputScorecardVersion || !supervisorNumber }
    );
    /* agent details for the entire scorecard*/
    const { data: allTeamLeadsScorecardAgentData } = useGetTeamLeadScorecardAgentsQuery(
        {
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: inputScorecardVersion,
        },
        { skip: !inputScorecardVersion }
    );

    const { data: scoreCardDisputesData } = useGetScoreCardDisputesQuery(
        {
            employeenumber: supervisorNumber,
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: inputScorecardVersion,
        },

        { skip: !empNum || !inputScorecardVersion }
    );

    useEffect(() => {
        setAgents(allTeamLeadsScorecardAgentData?.data.length > 0 ? allTeamLeadsScorecardAgentData.data : []);
        if (allTeamLeadsScorecardAgentData?.data.length > 0) {
            allTeamLeadsScorecardAgentData?.data.map((x: any) => {
                const obj = Object.keys(x?.agentMetrics[0]?.metricsDetails);
                setMetricColHeader(obj);
                return obj;
            });
        }
    }, [allTeamLeadsScorecardAgentData]);
    const SupervisorOnChange = (e: any) => {
        setSupervisorNumber(e.value);
    };

    useEffect(() => {
        setTlAgentData(teamLeadScorecardAgentData);
    }, [teamLeadScorecardAgentData]);

    type EmployeeTL = [
        {
            name: string;
            id: string;
        }
    ];
    useEffect(() => {
        if (scorecardSupervisorsData?.data?.length > 0) {
            const arrayOfUsers: EmployeeTL = scorecardSupervisorsData?.data?.map((item: any) => {
                const name = item?.agent_name ? item.agent_name.concat(' (', item.agent_number, ')') : '';
                return {
                    name,
                    id: item?.agent_number,
                };
            });

            setListOfTls(arrayOfUsers);
        }
    }, [scorecardSupervisorsData]);
    const onExportClick = () => {
        if (agents?.length > 0) exportExcel(agents, metricColHeader);
        else toast.info('No data found');
    };

    return (
        <div>
            {inputScorecardVersion > 0 ? (
                <>
                    <div>
                        <Dropdown
                            value={supervisorNumber}
                            onChange={SupervisorOnChange}
                            options={listOfTls}
                            optionValue={'id'}
                            optionLabel={'name'}
                            placeholder={'Select Team Lead'}
                            className="custom-dropdown me-3 mt-3 ms-3"
                        />
                        {module === 'eds' ? (
                            <Button
                                type="button"
                                style={{ marginTop: 16 }}
                                icon="pi pi-upload me-2"
                                className="btn-export mr-2 me-2 float-end"
                                onClick={onExportClick}
                                data-pr-tooltip="XLS"
                                disabled={agents?.length <= 0}
                            >
                                Export All
                            </Button>
                        ) : (
                            ''
                        )}
                    </div>
                    <Panel
                        header="Team Metrics"
                        toggleable
                        className="card mt-4 shadow bg-body rounded border-0"
                    >
                        <AgentScoreCardDashboardTabs
                            empNum={supervisorNumber}
                            inputmonth={inputMonth}
                            inputyear={inputYear}
                            scorecardVersion={inputScorecardVersion}
                        />
                    </Panel>
                    {tlAgentData?.data?.length > 0 ? (
                        <Panel
                            header="Team Stats"
                            toggleable
                            className="card mt-4 shadow bg-body rounded border-0"
                        >
                            <div className="row mt-4">
                                <div className="col-12">
                                    <div className="card shadow bg-body rounded border-0">
                                        <div className="card-body">
                                            <ScoreCardDashboardViewTable
                                                enableNavigateAgent={false}
                                                ScoreCardAgentdata={tlAgentData}
                                                inputMonth={inputMonth}
                                                inputYear={inputYear}
                                                supervisorNumber={supervisorNumber}
                                                scorecardVersion={inputScorecardVersion}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                    ) : (
                        ''
                    )}
                </>
            ) : (
                <MessageInfo
                    title="No results found."
                    message="Try adjusting the month or Scorecard filters above."
                    rowHeight="62vh"
                />
            )}

            <Panel
                header="Scorecard Disputes"
                toggleable
                className="card mt-4 shadow bg-body rounded border-0"
            >
                <ScorecardDisputesTable
                    scorecardVersion={inputScorecardVersion}
                    data={scoreCardDisputesData?.data}
                    isSubTab
                />
            </Panel>
        </div>
    );
};
